export const GENERIC_MESSAGE = 'Campo obrigatório';
export const GENERIC_PROCESS_ERROR = 'Houve um erro na operação desejada';
